module.exports = __webpack_public_path__ + "img/card.3bdc11dc.png";